import laydate from './laydate/laydate';
import Sloth from '../Sloth';
import './datepick.scss';
// import './laydate/theme/default/laydate.css';
import './style.scss';

@Sloth.component({
    defaultOptions:{}
})

export default class Datepick {
    onInit() {
        laydate.render({
            elem: this.dom,
            showBottom: false
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/Datepick/datepick.js
 **/